import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { useLocation } from "react-router-dom"
import routes from "routes"

import DashboardTour from "./DashboardTour"
import ImpactCourseTour from "./ImpactCourseTour"

const SuraasaPlusNewYearOnboarding = () => {
  const location = useLocation()
  const isLearningRoute = location.pathname === routes.learning
  const isCourseRoute = location.pathname.includes("/course")
  const { isSPNYUser } = useSuraasaPlusContext()

  if (!isSPNYUser) return null

  return (
    <>
      <DashboardTour />
      {(isLearningRoute || isCourseRoute) && <ImpactCourseTour />}
    </>
  )
}

export default SuraasaPlusNewYearOnboarding
